import { useQuery } from '@tanstack/react-query';
import { terraProxyApiClient } from '../../clients/testerClient';

const STALE_TIME_MS = 30_000;

export const INTERNAL_NETWORK_OWNED_PRINCIPALS_KEY =
  'internal-network-owned-principals';
export const INTERNAL_NETWORK_DISCOVERY_RUNS_KEY =
  'internal-network-discovery-runs';
export const INTERNAL_NETWORK_SIGNALS_TREND_KEY =
  'internal-network-signals-trend';

export function useInternalNetworkOwnedPrincipals({
  networkId,
  enabled = true,
}: {
  networkId: string | null;
  enabled?: boolean;
}) {
  const query = useQuery({
    queryKey: [INTERNAL_NETWORK_OWNED_PRINCIPALS_KEY, networkId],
    queryFn: () =>
      terraProxyApiClient.listInternalNetworkOwnedPrincipals({
        networkId: networkId ?? '',
        limit: 50,
      }),
    enabled: Boolean(networkId) && enabled,
    staleTime: STALE_TIME_MS,
  });

  return {
    ownedPrincipals: query.data?.data ?? [],
    total: query.data?.total ?? 0,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}

export function useInternalNetworkDiscoveryRuns({
  networkId,
  enabled = true,
}: {
  networkId: string | null;
  enabled?: boolean;
}) {
  const query = useQuery({
    queryKey: [INTERNAL_NETWORK_DISCOVERY_RUNS_KEY, networkId],
    queryFn: () =>
      terraProxyApiClient.listInternalNetworkDiscoveryRuns({
        networkId: networkId ?? '',
        limit: 10,
      }),
    enabled: Boolean(networkId) && enabled,
    staleTime: STALE_TIME_MS,
  });

  return {
    discoveryRuns: query.data?.data ?? [],
    total: query.data?.total ?? 0,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}

export function useInternalNetworkSignalsTrend({
  networkId,
  days = 30,
  enabled = true,
}: {
  networkId: string | null;
  days?: number;
  enabled?: boolean;
}) {
  const query = useQuery({
    queryKey: [INTERNAL_NETWORK_SIGNALS_TREND_KEY, networkId, days],
    queryFn: () =>
      terraProxyApiClient.getInternalNetworkSignalsTrend({
        networkId: networkId ?? '',
        days,
      }),
    enabled: Boolean(networkId) && enabled,
    staleTime: STALE_TIME_MS,
  });

  return {
    trend: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
